import { useContext } from 'react'

import { GretaAIChatContext } from '../../GretaAIChat.context'

export function useGretaAIChatContext() {
  return useContext(GretaAIChatContext)
}
